import { LogsRegistry } from '@app/pages/SalesFunnels/LogsRegistry/LogsRegistry.main';

export { LogsRegistry };
